/**
 * GeChiUI dependencies
 */
import { SVG, Path } from '@gechiui/primitives';

const alignNone = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M5 15h14V9H5v6zm0 4.8h14v-1.5H5v1.5zM5 4.2v1.5h14V4.2H5z" />
	</SVG>
);

export default alignNone;
